import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const formPacksRequest = createAction(types.FORMPACKS_REQUEST);
export const formPacksSuccess = createAction(types.FORMPACKS_SUCCESS);
export const formPacksFailure = createAction(types.FORMPACKS_FAILURE);

export const formPackRequest = createAction(types.FORMPACK_REQUEST);
export const formPackSuccess = createAction(types.FORMPACK_SUCCESS);
export const formPackFailure = createAction(types.FORMPACK_FAILURE);

export const createFormPackRequest = createAction(
  types.CREATE_FORMPACK_REQUEST,
);
export const createFormPackSuccess = createAction(
  types.CREATE_FORMPACK_SUCCESS,
);
export const createFormPackFailure = createAction(
  types.CREATE_FORMPACK_FAILURE,
);

export const updateFormPackRequest = createAction(
  types.UPDATE_FORMPACK_REQUEST,
);
export const updateFormPackSuccess = createAction(
  types.UPDATE_FORMPACK_SUCCESS,
);
export const updateFormPackFailure = createAction(
  types.UPDATE_FORMPACK_FAILURE,
);

export const deleteFormPackRequest = createAction(
  types.DELETE_FORMPACK_REQUEST,
);
export const deleteFormPackSuccess = createAction(
  types.DELETE_FORMPACK_SUCCESS,
);
export const deleteFormPackFailure = createAction(
  types.DELETE_FORMPACK_FAILURE,
);

export const resetFormPack = createAction(types.RESET_FORMPACK);

export default {
  resetFormPack,
  formPacksRequest,
  formPacksSuccess,
  formPacksFailure,
  formPackRequest,
  formPackSuccess,
  formPackFailure,
  createFormPackRequest,
  createFormPackSuccess,
  createFormPackFailure,
  updateFormPackRequest,
  updateFormPackSuccess,
  updateFormPackFailure,
  deleteFormPackRequest,
  deleteFormPackSuccess,
  deleteFormPackFailure,
};
